import { makeStyles } from "@mui/styles";

const useStyles: any = makeStyles(() => ({
  tablePaper: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    minHeight: 0,
    borderRadius: 4,
    border: "1px solid #e5e2e5",
    overflow: "hidden"
  },

  tableContainer: {
    position: "relative",
    flex: 1,
    minHeight: 0,
    overflow: "auto"
  },

  loadingOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 2,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(255, 255, 255, 0.6)"
  },

  headCell: {
    backgroundColor: "#f6f6f7",
    color: "#4b1c46",
    fontSize: "12px",
    fontWeight: 500,
    letterSpacing: "0.4px",
    whiteSpace: "nowrap"
  },

  row: {
    "&:hover": {
      backgroundColor: "#fbfafb"
    }
  },

  cell: {
    fontSize: "13px",
    color: "#333"
  },

  healthyIcon: {
    fontSize: "20px",
    color: "#3f7d3f",
    verticalAlign: "middle"
  },

  unhealthyIcon: {
    fontSize: "20px",
    color: "#d32f2f",
    verticalAlign: "middle"
  },

  viewIcon: {
    fontSize: "19px",
    color: "#736973"
  },

  emptyCell: {
    borderBottom: "none",
    padding: "48px 16px"
  },

  emptyText: {
    textAlign: "center",
    fontSize: "14px",
    fontStyle: "italic",
    color: "#8f8a8f"
  },

  pagination: {
    borderTop: "1px solid #e5e2e5",
    flexShrink: 0
  }
}));

export default useStyles;
